'use client'

import Box from '@mui/material/Box'

import styled from '@emotion/styled'

const Container = styled(Box)`
  background-color: #ffffff;
  color: #171717;
  min-height: 100vh;
`

export default function Wrapper({
  children,
  style,
}: React.PropsWithChildren<{ style?: React.CSSProperties }>) {
  return (
    <Container className='home-wrapper' style={style}>
      {children}
    </Container>
  )
}
